import Slider from './Layout/Slider';
import Style from './Style';

const Layout = ({ settings, items, height, sliderPlay }) => {

    const styleProps = { height }
    const generalProps = { settings, items, sliderPlay }

    return <div className="layout">
        <Style {...styleProps} />
        <Slider {...generalProps} />
    </div>
}
export default Layout;